import * as React from 'react';
import { sprykerPlaceholderImage, sprykerProductImageSrcSet } from '../../../react/common/lib';
import { IProductItemImages } from '../../interfaces';
import { pushProductClickToDataLayer, buildConfigProduct } from 'PyzShopUi/scripts/shop-ui/services/ProductClickTrackingService'
import { useProductListName } from './ProductItemListNameContext'

interface IProductItemCompactProps {
    name: string;
    url: string;
    images: IProductItemImages;
    sku: string;
    merchantPrice: number;
    customerPrice: number;
}

const ProductItemCompact: React.FunctionComponent<IProductItemCompactProps> = ({ sku, name, customerPrice, merchantPrice, ...props }) => {
    const listName = useProductListName();

    const onClickHandler = () => {
        const products = buildConfigProduct({ id: sku, name, customerPrice, merchantPrice });

        pushProductClickToDataLayer({ actionField: { list: listName }, products })
    }

    return (
        <div className='product-item product-item-compact' onClick={onClickHandler}>
            <div className='product-image-cover lazy-image-container'>
                <a itemProp='url' className='product-image-cover__full-link' href={props.url} />
                <img
                    alt={name}
                    src={sprykerPlaceholderImage()}
                    className='product-image lazyload'
                    data-src={props.images.externalUrlThumbnail}
                    data-srcset={sprykerProductImageSrcSet(props.images)}
                />
            </div>
        </div>
    );
}

export default ProductItemCompact;
